module.exports = __webpack_public_path__ + "img/lambdoge.778e2e5c.png";